export { default } from "./NewPassword";
